export { default } from "./NewPassword";
